import * as L from "leaflet";
import { leafletLayer, LineSymbolizer } from "protomaps-leaflet";

const shUrlNew = "//tiles.webman.at/";
const osmAttribution =
  '© <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' +
  ', <a href="http://www.eea.europa.eu/data-and-maps/data/eu-dem">eu-dem</a>';
const baseLayer = new L.TileLayer(shUrlNew + "snowhow/{z}/{x}/{y}", {
  attribution: osmAttribution,
  minZoom: 8,
  // errorTileUrl: 'icon/missing_tile.png',
  bounds: [
    [45.18, 6.3],
    [48, 16.15]
  ],
  maxZoom: 17
});
const pistsLayer = new L.TileLayer(shUrlNew + "pists/{z}/{x}/{y}", {
  attribution: "",
  minZoom: 8,
  errorTileUrl: "icon/missing_tile.png",
  opacity: 0.4,
  bounds: [
    [46.7768, 10.2832],
    [47.5276, 12.4801]
  ],
  maxZoom: 17
});
const slopeLayer = new L.TileLayer(shUrlNew + "slope/{z}/{x}/{y}", {
  attribution:
    '<a href="http://www.tirol.gv.at/organisation/verwaltungsentwicklung/informationsweiterverwendung/">' +
    'Tirol</a>, <a href="http://www.provinz.bz.it/informatik/">Prov.Bozen</a>, ' +
    '<a href="http://www.vorarlberg.at/lva">Vorarlberg</a>',
  // ' <a href="http://www.eea.europa.eu/data-and-maps/data/eu-dem">eu-dem</a>, '
  opacity: 0.4,
  className: "freerideinfoWarning",
  minZoom: 14,
  maxZoom: 17
});

var basemap_url =
  "//maps.wien.gv.at/basemap/bmapgrau/normal/google3857/{z}/{y}/{x}.png";
var basemap_at = new L.TileLayer(basemap_url, {
  attribution: "<a href='//www.basemap.at'>basemap.at</a>",
  bounds: [
    [46.35877, 8.782379],
    [49.037872, 17.189532]
  ],
  minZoom: 8,
  maxZoom: 17
});
const orthoLayer = new L.TileLayer(
  "//maps.wien.gv.at/basemap/bmaporthofoto30cm/normal/google3857/{z}/{y}/{x}.jpg",
  {
    attribution: "<a href='//www.basemap.at'>basemap.at</a>",
    bounds: [
      [46.35877, 8.782379],
      [49.037872, 17.189532]
    ],
    minZoom: 8,
    maxZoom: 17
  }
);

const pmtilesLayer = leafletLayer({
  url: "https://maps.webman.at/world.pmtiles",
  flavor: "light"
});

const contourLayer = leafletLayer({
  url: "https://maps.webman.at/tyrol-contours.pmtiles",
  zIndex: 5,
  paintRules: [
    {
      dataLayer: "contours",
      minzoom: 11,
      symbolizer: new LineSymbolizer({
        color: "#a07040",
        width: 0.5,
        opacity: 0.55
      }),
      filter: (_zoom, f) => f.props.major != 1
    },
    {
      dataLayer: "contours",
      minzoom: 9,
      symbolizer: new LineSymbolizer({
        color: "#a07040",
        width: 1.0,
        opacity: 0.8
      }),
      filter: (_zoom, f) => f.props.major == 1
    }
  ],
  labelRules: []
});

export {
  baseLayer,
  slopeLayer,
  pistsLayer,
  basemap_at,
  orthoLayer,
  pmtilesLayer,
  contourLayer
};
